import {getEnv} from '../common/env/env';
import {
  KAKAOTALK_CONTENTS_HOME_VIEWER_TEMPLATE_ID,
  KAKAOTALK_CONTENTS_HOME_VIEWER_TEMPLATE_ID_SANDBOX,
  KAKAOTALK_DEFAULT_TEMPLATE_ID,
  KAKAOTALK_DEFAULT_TEMPLATE_ID_SANDBOX,
} from './constants';

export function getKakaotalkTemplateId({
  templateId,
  url,
}: {
  templateId?: number;
  url: string;
}) {
  if (templateId) {
    return templateId;
  }

  if (url.includes('/content') || url.includes('/viewer')) {
    return getEnv().useSandboxKakao
      ? KAKAOTALK_CONTENTS_HOME_VIEWER_TEMPLATE_ID_SANDBOX
      : KAKAOTALK_CONTENTS_HOME_VIEWER_TEMPLATE_ID;
  }

  return getEnv().useSandboxKakao
    ? KAKAOTALK_DEFAULT_TEMPLATE_ID_SANDBOX
    : KAKAOTALK_DEFAULT_TEMPLATE_ID;
}
